import { render, staticRenderFns } from "./TabHardware.vue?vue&type=template&id=1b13ae06&scoped=true&"
import script from "./TabHardware.vue?vue&type=script&lang=js&"
export * from "./TabHardware.vue?vue&type=script&lang=js&"
import style0 from "./TabHardware.vue?vue&type=style&index=0&id=1b13ae06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b13ae06",
  null
  
)

export default component.exports